import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &:hover {
    input {
      ::after {
        background: ${props => props.theme.unisystem.radioButton.check};
      }
    }
  }
`;

export const RadioWrapper = styled.span`
  display: flex;
  align-items: center;
  ${props => props.theme.gap(2.5)};
`;

export const Label = styled.label`
  font-size: ${props => props.theme.rem(props.isSmall ? 14 : 16)};
  line-height: ${props => props.theme.rem(props.isSmall ? 19 : 20)};
  color: ${props => props.theme.unisystem.radioButton.label};
  pointer-events: none;
`;

export const Radio = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: ${props => (props.isSmall ? '16px' : '24px')};
  height: ${props => (props.isSmall ? '16px' : '24px')};
  border-style: solid;
  border-width: ${props => (props.isSmall ? '1px' : '2px')};
  border-color: ${props =>
    props.isDisabled ? props.theme.unisystem.radioButton.disabled.border : props.theme.unisystem.radioButton.border};
  border-radius: 50%;
  cursor: pointer;

  ::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: ${props => (props.isSmall ? '10px' : '14px')};
    height: ${props => (props.isSmall ? '10px' : '14px')};
    margin: ${props => (props.isSmall ? '2px' : '3px')};
  }

  :hover {
    ::after {
      background: ${props => props.theme.unisystem.radioButton.check};
    }
  }

  :checked {
    cursor: auto;
    background: inherit;

    ::after {
      background: ${props => props.theme.unisystem.radioButton.check};
    }
  }

  ${props => props.isErrored && 'border-color: #F7988B'};

  ${props =>
    props.isDisabled &&
    `
      background: ${props.theme.unisystem.radioButton.disabled.background};
      pointer-events: none;

      :checked {
        ::after {
          background: ${props.theme.unisystem.radioButton.disabled.check};
        }
      }
 `}
`;
